import {useSocket} from 'socket.io-react-hook';
import {UseSocketOptions} from 'socket.io-react-hook/lib/cjs/types';

import {envConfig} from 'config';
import {RECONNECTION_ATTEMPTS} from 'constants/socket';
import {SocketNamespace} from 'enums';

export const useNamespaceSocket = <T>(namespace: SocketNamespace, options?: UseSocketOptions<T>) =>
    useSocket(envConfig.socketApiUrl + '/' + namespace, {
        transports: ['websocket', 'polling'], // use WebSocket first, if available
        reconnectionAttempts: RECONNECTION_ATTEMPTS,
        reconnectionDelay: 1000,
        ...(options && options),
    });